import { NgModule } from '@angular/core';
import { MatRadioModule } from '@angular/material/radio';

@NgModule({
  imports: [MatRadioModule],
  exports: [MatRadioModule]
})
export class TiimeRadioModule {}
